/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limits_TitleInputs */

const en_svc_rag_limits_title = /** @type {(inputs: Svc_Rag_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where a RAG system stops.`)
};

const lv_svc_rag_limits_title = /** @type {(inputs: Svc_Rag_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kur RAG sistēma apstājas.`)
};

/**
* | output |
* | --- |
* | "Where a RAG system stops." |
*
* @param {Svc_Rag_Limits_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limits_title = /** @type {((inputs?: Svc_Rag_Limits_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limits_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limits_title(inputs)
	return en_svc_rag_limits_title(inputs)
});